module.exports = __webpack_public_path__ + "static/cbam-comparing-1-775b70c394ae525d9f1423a493b8a6f0.png";